import React, { useState, useEffect } from 'react';
import { Select, Card, Avatar, Row, Col, Typography, Progress, Alert } from 'antd';
import { db } from '../firebase/config';
import { collection, query, where, getDocs, doc, getDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../components/auth/AuthContext';
import { message } from 'antd';
import { onSnapshot } from 'firebase/firestore';
const { Option } = Select;
const { Title, Text } = Typography;


const LandingPage = () => {
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [users, setUsers] = useState([]);
  const [userVotingStatus, setUserVotingStatus] = useState(null);
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [selectedState, setSelectedState] = useState('Tamil Nadu');
  const [selectedDistrict, setSelectedDistrict] = useState('Madurai');
  const VOTERS_PER_DISTRICT = 100; // Constants for total voters per district


  // Add these styles at the top
  const styles = {
    container: {
      padding: '24px',
      maxWidth: '1200px',
      margin: '0 auto',
    },
    header: {
      textAlign: 'center',
      marginBottom: '32px',
      marginTop: '60px',  // Fixed spelling from 'margintTop' to 'marginTop'
    },
    rankingCard: {
      backgroundColor: '#f8f9fa',
      padding: '24px',
      borderRadius: '8px',
      marginBottom: '32px',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',


    },
    rankingTitle: {
      marginBottom: '24px',
      color: '#1a1a1a',
      textAlign: "center"
    },
    rankingItem: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: '#ffffff',
      padding: '16px',
      borderRadius: '8px',
      marginBottom: '12px',
      cursor: 'pointer',
      transition: 'transform 0.2s ease, box-shadow 0.2s ease',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
      '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      },
    },
    rankNumber: {
      width: '32px',
      height: '32px',
      borderRadius: '50%',
      backgroundColor: '#1890ff',
      color: '#ffffff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 'bold',
      marginRight: '16px',
    },
    userInfo: {
      display: 'flex',
      alignItems: 'center',
      flex: 1,
    },
    userAvatar: {
      marginRight: '16px',
    },
    userDetails: {
      flex: 1,
    },
    userName: {
      fontSize: '16px',
      fontWeight: '600',
      color: '#262626',
      marginBottom: '4px',
    },
    userLocation: {
      fontSize: '14px',
      color: '#8c8c8c',
    },
    voteInfo: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      minWidth: '120px',
    },
    voteCount: {
      fontSize: '15px',
      fontWeight: '600',
      color: '#1890ff',
      marginBottom: '8px',
    },
    progressContainer: {
      width: '100px',
    },
    filtersContainer: {
      display: 'flex',
      gap: '16px',
      marginBottom: '32px',
      justifyContent: 'center',
      flexWrap: 'wrap',
    },
    select: {
      width: '200px',
    },
    memberCard: {
      textAlign: 'center',
      padding: '20px',
      height: '100%',
      transition: 'all 0.3s ease',
      '&:hover': {
        transform: 'translateY(-5px)',
      },
    },
    rankingCard: {
      maxWidth: "500px",
      // backgroundColor: '#f8f9fa',
      // padding: '20px',
      // borderRadius: '8px',
      marginBottom: '24px',
      marginTop: '50px',
      // boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
      marginLeft: 'auto',
      marginRight: 'auto',  // These two margin properties will center the div
    },

    rankingItem: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: '#ffffff',
      padding: '12px',
      borderRadius: '8px',
      marginBottom: '8px',
      cursor: 'pointer',
      transition: 'transform 0.2s ease',
      '&:hover': {
        transform: 'translateY(-2px)',
      }
    },
    rankNumber: {
      width: '28px',
      height: '28px',
      borderRadius: '50%',
      backgroundColor: '#1890ff',
      color: '#ffffff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 'bold',
      marginRight: '12px',
    },
    userName: {
      fontSize: '15px',
      fontWeight: '600',
      marginLeft: '8px',
    },
    voteCount: {
      marginLeft: 'auto',
      color: '#1890ff',
      fontWeight: '600',
    }
  };
  // Add this useEffect to fetch districts when component mounts
  useEffect(() => {
    fetchStates();
    if (selectedState) {
      fetchDistricts(selectedState);
    }
    if (currentUser) {
      checkUserVotingStatus();
    }
  }, [currentUser]);
  // Add this new useEffect for real-time updates
  useEffect(() => {
    const votesRef = collection(db, 'userVotes');


    const unsubscribe = onSnapshot(votesRef, (snapshot) => {
      snapshot.docChanges().forEach(() => {
        fetchUsers(); // This will refresh the users data including votes
      });
    });


    return () => unsubscribe(); // Cleanup subscription
  }, [selectedState, selectedDistrict]);


  // Add this useEffect to fetch users when component mounts
  useEffect(() => {
    if (selectedState && selectedDistrict) {
      fetchUsers();
    }
  }, []);
  // Add new function to sort users by votes
  // Update the getTop5Users function
  const getTop5Users = () => {
    return [...users]
      .filter(user => calculateTotalVoters(user.votes) > 0) // Filter out users with 0 votes
      .sort((a, b) => {
        const aVotes = calculateTotalVoters(a.votes);
        const bVotes = calculateTotalVoters(b.votes);
        return bVotes - aVotes;
      })
      .slice(0, 5);
  };
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const stateParam = params.get('state');
    const districtParam = params.get('district');

    if (stateParam) {
      setSelectedState(stateParam);
      fetchDistricts(stateParam);
    }
    if (districtParam) {
      setSelectedDistrict(districtParam);
    }
  }, []);



  // Add this component to display when no votes are found
  const NoVotesMessage = () => (
    <div style={{
      textAlign: 'center',
      padding: '24px',
      color: '#8c8c8c',
      fontSize: '16px'
    }}>
      No votes recorded yet
    </div>
  );
  useEffect(() => {
    fetchStates();
    if (currentUser) {
      checkUserVotingStatus();
    }
  }, [currentUser]);
  // Add this function inside the LandingPage component
  const calculateVotePercentage = (userVotes) => {
    if (!userVotes || !userVotes.question1) return 0;

    const totalVotesForUser = (userVotes.question1.yes || 0) + (userVotes.question1.no || 0);
    // Calculate percentage based on VOTERS_PER_DISTRICT (10 voters = 100%)
    return Math.round((totalVotesForUser / VOTERS_PER_DISTRICT) * 100);
  };
  // Updated function to get progress status based on percentage
  const getProgressStatus = (percentage) => {
    if (percentage >= 100) return 'success';
    if (percentage >= 50) return 'active';
    return 'normal';
  };


  // Update the checkUserVotingStatus function
  const checkUserVotingStatus = async () => {
    if (!currentUser) return;


    try {
      const userVotesDoc = await getDoc(doc(db, 'userVotes', currentUser.uid));
      if (userVotesDoc.exists()) {
        const votesData = userVotesDoc.data();
        if (votesData.hasVoted) {
          message.info(`You have already voted for candidate ID: ${votesData.votedFor}`);
        }
        setUserVotingStatus({
          hasVoted: votesData.hasVoted,
          votedFor: votesData.votedFor,
          votedAt: votesData.votedAt
        });
      }
    } catch (error) {
      console.error('Error checking voting status:', error);
      message.error('Failed to check voting status');
    }
  };
  const fetchStates = async () => {
    const statesRef = collection(db, 'states');
    const snapshot = await getDocs(statesRef);
    const statesData = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    setStates(statesData);
  };


  const fetchDistricts = async (state) => {
    const districtsRef = collection(db, 'districts');
    const q = query(districtsRef, where('state', '==', state));
    const snapshot = await getDocs(q);
    const districtsData = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    setDistricts(districtsData);
  };


  const fetchUsers = async () => {
    if (selectedState && selectedDistrict) {
      const usersRef = collection(db, 'users');
      const q = query(
        usersRef,
        where('state', '==', selectedState),
        where('district', '==', selectedDistrict)
      );
      const snapshot = await getDocs(q);
      const usersData = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setUsers(usersData);
    }
  };


  useEffect(() => {
    if (selectedState && selectedDistrict) {
      fetchUsers();
    }
  }, [selectedState, selectedDistrict]);


  // Update the calculateTotalVotes function
  const calculateTotalVoters = (votes) => {
    if (!votes || !votes.question1) return 0;
    const questionData = votes.question1;
    return (questionData.yes || 0) + (questionData.no || 0);
  };
  const handleStateChange = (value) => {
    setSelectedState(value);
    fetchDistricts(value);
    setSelectedDistrict(null);
    setUsers([]);
  };


  const handleCardClick = (userId) => {
    if (!currentUser) {
      navigate('/login');
      return;
    }
    navigate(`/profile/${userId}`);
  };
  const getVoteDisplay = (votes) => {
    const totalVotes = calculateTotalVoters(votes);
    return `${totalVotes}/${VOTERS_PER_DISTRICT} votes`;
  };


  return (
    <div style={styles.container}>

      <div style={styles.rankingCard}>
        <Title level={1} style={styles.rankingTitle}>Top Representatives</Title>
        {getTop5Users().length > 0 ? (
          getTop5Users().map((user, index) => (
            <div
              key={user.id}
              style={styles.rankingItem}
              onClick={() => handleCardClick(user.id)}
            >
              <div style={styles.rankNumberContainer}>
                <div style={styles.rankNumber}>{index + 1}</div>
              </div>
              <div style={styles.userInfo}>
                <Avatar
                  src={user.profileImage}
                  size={window.innerWidth <= 768 ? 40 : 48}
                  style={styles.userAvatar}
                />
                <div style={styles.userDetails}>
                  <div style={styles.userName}>{user.username}</div>
                  <div style={styles.userLocation}>
                    {getVoteDisplay(user.votes)} ({calculateVotePercentage(user.votes)}%)
                  </div>
                </div>
              </div>
              {/* <Progress 
              percent={calculateVotePercentage(user.votes)}
              size="small"
              status={getProgressStatus(calculateVotePercentage(user.votes))}
              style={{ width: 100 }}
            /> */}
            </div>
          ))
        ) : (
          <NoVotesMessage />
        )}
      </div>


      <div style={styles.header}>
        <Title level={2}>Elected Representatives</Title>
      </div>


      {/* Filters section remains the same */}
      <div style={styles.filtersContainer}>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '8px'
        }}>
          <label style={{
            fontSize: '14px',
            fontWeight: '500',
            color: '#262626'
          }}>
            State
          </label>
          <Select
            style={styles.select}
            placeholder="Select State"
            onChange={handleStateChange}
            value={selectedState}
            defaultValue="Tamil Nadu"
          >
            {states.map(state => (
              <Option key={state.id} value={state.name}>{state.name}</Option>
            ))}
          </Select>
        </div>


        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '8px'
        }}>
          <label style={{
            fontSize: '14px',
            fontWeight: '500',
            color: '#262626'
          }}>
            District
          </label>
          <Select
            style={styles.select}
            placeholder="Select District"
            onChange={setSelectedDistrict}
            value={selectedDistrict}
            disabled={!selectedState}
            defaultValue="Chennai"
          >
            {districts.map(district => (
              <Option key={district.id} value={district.name}>{district.name}</Option>
            ))}
          </Select>
        </div>
      </div>



      <Row gutter={[24, 24]}>
        {users.map(user => (
          <Col xs={24} sm={12} md={8} lg={6} key={user.id}>
            <Card
              hoverable
              style={styles.memberCard}
              onClick={() => handleCardClick(user.id)}
            >
              <Avatar
                size={100}
                src={user.profileImage}
                style={styles.avatar}
              />
              <div style={styles.memberInfo}>
                <Title level={4}>{user.username}</Title>
                <Text>{user.district}, {user.state}</Text>
                <div style={styles.voteStats}>
                  <Text strong>{getVoteDisplay(user.votes)}</Text>
                  <Progress
                    percent={calculateVotePercentage(user.votes)}
                    size="small"
                    status={getProgressStatus(calculateVotePercentage(user.votes))}
                    format={percent => `${percent}%`}
                  />
                </div>
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    </div>);
};


export default LandingPage;